import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function MirrorIcon({ minimal, ...rest }: SvgIconProps & { minimal?: boolean }) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...rest}>
            <path
                d="M21.2227 8.38867C21.5549 8.16718 22 8.40537 22 8.80469V15.1992C22 15.5985 21.5549 15.8367 21.2227 15.6152L16.4268 12.418C16.1299 12.2201 16.1299 11.7839 16.4268 11.5859L21.2227 8.38867Z"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path
                d="M1.75 9.00195C1.75 7.76589 3.16115 7.06031 4.15 7.80195L8.15 10.802C8.95 11.402 8.95 12.602 8.15 13.202L4.15 16.202C3.16115 16.9436 1.75 16.238 1.75 15.002V9.00195Z"
                fill="currentColor"
            />
            <rect x="11" y="5" width="2" height="14" rx="1" fill="#F8F8F8" />
        </SvgIcon>
    )
}
